<template>
    <div class="container form-container p-4">
        <div class="text-3xl mb-4 pb-2 font-light flex items-end justify-between">
            <div data-cy="company-settings-audit-logs-title">
                {{ $t('company.audit_logs.title') }}
            </div>
        </div>
        <audit-log-table :company_id="company_id" ref="AuditLogsTable"></audit-log-table>
    </div>
</template>

<script>
import AuditLogTable from '@/components/tables/AuditLogs.vue';

export default {
    components: {
        AuditLogTable,
    },
    props: {
        company_id: {
            type: String,
            default: '',
        },
    },
    methods: {
        reload() {
            this.$refs.AuditLogsTable.reload();
        },
    },
};
</script>
